<template>
  <div class="page-wrapper">
    <search-list
    @searchParams="search"
    :projectList="projectList"
    :oneStep="oneStep"
    :orderStatusList="orderStatusList"
    ></search-list>
    <div >
      <Button v-p="{api:'workOrder/dealWorkOrder'}" type="primary" @click.stop="addN++" class="mb16">新增</Button>
      <Button v-p="{api:'workOrder/exportWorkOrderList'}" type="primary" :loading = "btnLoading" @click="exportFile()" class="mb16" style="margin-left:10px">导出</Button>
    </div>
    <add
    :n="addN"
    :projectList="projectList"
    :orderStatusList="orderStatusList"
    :oneStep="oneStep2"
    @done="getSearchData"
    ></add>
    <done
    :d="addD"
    :projectFid="projectFid"
    :score="score"
    :workOrderFid="workOrderFid"
    @done="getSearchData"
    ></done>
    <check
    :c="addM"
    :item="item"
    ></check>
    <table-list
      :columns="columns"
      :data="data"
      :current="current"
      :total="total"
      :loading="loading"
      @change-page="changPage"
    >
    </table-list>
  </div>
</template>

<script>
import { getProjects } from 'api/common'
import SearchList from './components/SearchList'
import Add from './components/Add'
import Done from './components/Done'
import Check from './components/Check'
import TableList from 'components/TableList/index';
import {formatDateTime} from "../../../../../utils/format"

import { findWorkOrderTypeList,findWorkOrderList,deleteWorkOrder ,exportWorkOrderList} from 'api/workOrder'
import {findWorkOrderTypeListV2} from "../../../../../api/performanceManager";

export default {
  name:'serviceOrder',
  components:{
    SearchList,
    Add,
    TableList,
    Done,
    Check
  },
  data(){
    return{
      oneStep2:[],
      btnLoading:false,
      item:null,
      addN:0,
      addD:0,
      addM:0,
      current:1,
      score:0,
      page:1,
      limit:10,
      total:0,
      loading:false,
      projectFid:'',
      oneStep:[],
      workOrderFid:'',
      orderStatusList:[
        {
          text:'办理中',
          value:0,
        },{
          text:'已办结',
          value:1,
        }
      ],
      data:[],
      projectList:[],
      columns:[
        {
          title:'项目名称',
          key: 'projectName',
          width: 200,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title:'合同号',
          key: 'contractCode',
          width: 150,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title:'房间号',
          key: 'houseNumber',
          width: 220,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title:'一级分类',
          key: 'orderTypeParentName',
          width: 150,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title:'二级分类',
          key: 'orderTypeName',
          width: 150,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title:'工单状态',
          key: 'orderStatusName',
          width: 100,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title:'办理人',
          key: 'dealZoName',
          width: 100,
          align: 'center',
        },
        {
          title: ' '
        },
        {
          title:'计分',
          key: 'dealZoScore',
          width: 80,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title:'答谢人',
          key: 'thankZoName',
          width: 100,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title:'计分',
          key: 'thankZoScore',
          width: 80,
          align: 'center'
        },
        {
          title: ' '
        },
        {
          title:'创建日期',
          key: 'createDate',
          width: 160,
          align: 'center',
          render: (h, params) => {
            return h('span', {}, this.format(params.row['createDate']))
          }
        },
        {
          title: ' '
        },
        {
          title: '操作',
          align: 'center',
          width: 150,
          fixed: 'right',
          render:(h,params)=>{
            return [
              h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'workOrder/dealWorkOrder'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.$nextTick( ()=> {
                      this.addD++;
                      this.projectFid = params.row['projectFid']
                      this.score = params.row['orderScore']
                      this.workOrderFid = params.row['fid']
                    })
                  }
                },
                style: {
                  display:params.row['orderStatus']?'none':'',
                  marginRight: '10px'
                }
              }, '办结'),
              h('a', {
                on: {
                  click: () => {
                    this.$nextTick( ()=> {
                      this.addM++;
                      this.item = params.row;
                    })
                  }
                },
                style: {
                  marginRight: '10px'
                }
              }, '查看'),
              h('a', {
                directives:[
                  {
                    name:'p',
                    value:{
                      api:'workOrder/deleteWorkOrder'
                    }
                  }
                ],
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '删除工单',
                      content: '<p>确认删除本条工单？</p>',
                      onOk: () => {
                        const params2 = {
                          workOrderFid:params.row['fid']
                        }
                        deleteWorkOrder(params2)
                        .then( res => {
                          if(res.code === 0){
                            this.$Message.success('删除成功')
                            this.getSearchData();
                          } else{
                            this.$Message.info( '删除失败')
                          }
                        })
                        .catch( err => {
                          this.$Message.info( '删除失败')
                        })
                        .finally( ()=> {
                          this.isShow = false
                        })
                      }
                    })
                  }
                },
                style: {
                  display:params.row['orderStatus']?'none':'',
                }
              }, '删除')
            ]
          }
        },
        {
          title: ' '
        },
      ]
    }
  },
  created(){
    this.getProjectsData();
    this.getWorkOrderTypeList()
    findWorkOrderTypeListV2(
      {
        parentFid:-1,
        type:1,
      }
    ).then(res=>{
      this.oneStep2=res.data

    }).catch(error=>{})
  },
  methods:{
    exportFile(){
      let data = {};
        for (let key in this.searchParams) {
          if(key==='page' || key==='limit') continue;
          data[key] = this.searchParams[key]
        }
        this.btnLoading = true;
        exportWorkOrderList(data).then( res => {
          if(res.headers.count > 10000){
            this.btnLoading = false;
            this.$Modal.info({
              title: '导出合同',
              content:'上限10000条，请选择条件后下载'
            });
          } else{
            let filename = res.headers.filename || 'excel.xls';
            let blob = new Blob([res.data]);
            let url = window.URL.createObjectURL(blob);
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            this.btnLoading = false
          }
        }).catch( err => {
          this.btnLoading = false;
          console.log(err)
        })
    },
    getProjectsData(){
      getProjects()
      .then(res => {
        this.projectList = res.data;
      })
    },
    getWorkOrderTypeList(){
      findWorkOrderTypeList({
        parentFid:-1,
        type:1,
      })
      .then( res => {
        this.oneStep = res.data;
      })
    },
    search(data){
      this.searchParams = data
      this.page=1
      this.current=1
      this.getSearchData();
    },
    getSearchData(){
      let params= {
        ...this.searchParams,
        page:this.page,
        limit:this.limit
      }
      findWorkOrderList(params)
      .then( res => {
        this.data = res.data.rows
        this.total = res.data.total
      })
    },
    changPage(n){
      this.current = n;
      this.page = n;
      this.getSearchData()
    },
    format(data, showTime = true) {
      if (!data) {
        return ''
      }
      return formatDateTime(data, showTime)
    }
  }
}
</script>

<style>

</style>
